import styled, { css } from 'styled-components';
import { Button } from 'react-bootstrap';

const ButtonInputType = styled(Button)`${
  (props) => css`
    color: ${props.button.foreground};
    background-color: ${props.button.background};
    border-color: ${props.button.background};
    :disabled { 
      color: ${props.button.foreground};
      background-color: ${props.button.background};
      border-color: ${props.button.background};
    }
  `
}`;

export default ButtonInputType;
